import { render, staticRenderFns } from "./CoSyncListItemStatus.vue?vue&type=template&id=32b9ae2b&scoped=true&"
import script from "./CoSyncListItemStatus.vue?vue&type=script&lang=ts&"
export * from "./CoSyncListItemStatus.vue?vue&type=script&lang=ts&"
import style0 from "./CoSyncListItemStatus.vue?vue&type=style&index=0&id=32b9ae2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b9ae2b",
  null
  
)

export default component.exports